<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="fullPage"
        >
        </loading>

        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Advertiser Performance</h3>
            </d-col>
        </d-row>

        <d-row no-gutters class="dataTables_wrapper">
            <d-form inline> </d-form>
        </d-row>

        <d-row>
            <d-col lg="12" class="mb-4">
                <d-card class="card-small">
                    <d-card-header class="border-bottom">
                        <d-row>
                            <d-col sm="3" xs="12" class="mb-2">
                                <h6 class="m-0">Filters</h6>
                            </d-col>
                            <d-col
                                sm="9"
                                xs="12"
                                class="d-flex justify-content-center justify-content-md-end"
                            >
                                <export-performance
                                    :start-date="dateRange.from"
                                    :end-date="dateRange.to"
                                    :type="type"
                                    :page="page"
                                    @exportPerformance="onExportPerformance"
                                />
                            </d-col>
                        </d-row>
                    </d-card-header>

                    <d-list-group flush>
                        <d-list-group-item class="pl-3 pr-3 pt-4 pt-0">
                            <d-row>
                                <d-col>
                                    <d-form
                                        id="performanceForm"
                                        @submit.prevent="
                                            getPerformance(
                                                'advertiser',
                                                1,
                                                true,
                                                reviewed,
                                            )
                                        "
                                    >
                                        <d-form-row>
                                            <d-col
                                                md="4"
                                                class="form-group performance-form"
                                            >
                                                <b-form-select
                                                    v-model="
                                                        extraFilter.chosenAdvertiserNamesFilter
                                                    "
                                                    :options="advertiserNames"
                                                />
                                            </d-col>
                                            <d-col
                                                md="4"
                                                class="form-group performance-form"
                                            >
                                                <b-form-select
                                                    v-model="
                                                        extraFilter.website
                                                    "
                                                    :options="websitesSelectValues"
                                                />
                                            </d-col>
                                            <d-col
                                                md="4"
                                                class="form-group performance-form"
                                            >
                                                <d-input-group
                                                    class="date-range"
                                                >
                                                    <calendar-picker
                                                        :date-range="dateRange"
                                                    />
                                                </d-input-group>
                                            </d-col>
                                            <d-col
                                                md="4"
                                                class="form-group performance-form"
                                            >
                                                <d-input-group>
                                                    <input
                                                        value="Apply filter"
                                                        type="submit"
                                                        class="btn mr-1 btn-primary"
                                                    />
                                                    <input
                                                        type="button"
                                                        value="Reset filter"
                                                        @click="
                                                            resetFilter(
                                                                'advertiser'
                                                            )
                                                        "
                                                        class="btn mr-1 btn-secondary"
                                                    />
                                                </d-input-group>
                                            </d-col>
                                        </d-form-row>
                                    </d-form>
                                </d-col>
                            </d-row>
                        </d-list-group-item>
                    </d-list-group>
                </d-card>
            </d-col>
        </d-row>
        <d-card class="card-small">
            <div v-if="!isPerformanceLoading">
                <v-client-table
                    class="dataTables_wrapper"
                    :data="Performances"
                    :columns="columns"
                    :options="clientTableOptions"
                >
                    <span slot="advertiser" slot-scope="props">
                        {{ props.row.name }}
                    </span>
                    <span slot="approvedNumber" slot-scope="props">
                        {{ props.row.approvedNumber }}
                    </span>
                    <span slot="approved" slot-scope="props">
                        €{{ props.row.approved | toDec }}
                    </span>
                    <span slot="pendingNumber" slot-scope="props">
                        {{ props.row.pendingNumber }}
                    </span>
                    <span slot="open" slot-scope="props">
                        €{{ props.row.open | toDec }}
                    </span>
                    <span slot="disapprovedNumber" slot-scope="props">
                        {{ props.row.disapprovedNumber }}
                    </span>
                    <span slot="disapproved" slot-scope="props">
                        €{{ props.row.disapproved | toDec }}
                    </span>
                    <span slot="number" slot-scope="props">
                        {{ props.row.number }}
                    </span>
                    <span slot="total" slot-scope="props">
                        €{{ props.row.total | toDec }}
                    </span>
                    <span slot="approvalRate" slot-scope="props">
                        {{ props.row.approvalRate + " %" }}
                    </span>
                    <span
                        v-if="areAdvertiserTransactions"
                        slot="showTransactions"
                        slot-scope="props"
                    >
                        <button
                            class="btn mr-1 btn-primary"
                            @click="toggleShowTransactions"
                        >
                            {{
                                isOpened
                                    ? "Hide transactions"
                                    : "Show transactions"
                            }}
                        </button>
                    </span>
                </v-client-table>
                <transition name="fade">
                    <div
                        class="transaction-row__content transaction-row__content--scrollable"
                        v-if="isOpened"
                    >
                        <div v-if="transactions.length > 0" class="table mb-0">
                            <div class="border-bottom card-header">
                                <div class="row">
                                    <h6 class="m-0">
                                        Transactions
                                    </h6>
                                </div>
                            </div>
                            <transaction-row-item
                                v-for="transaction in transactions"
                                :key="transaction.id"
                                :transaction="transaction"
                                :currency="getCurrencies(transaction.domain)"
                            />
                        </div>
                        <div v-else>
                            <h6 class="text-center">No transactions</h6>
                        </div>
                    </div>
                </transition>
            </div>
            <d-container class="d-flex justify-content-center" fluid v-else>
                <b-spinner label="Spinning"></b-spinner>
            </d-container>
        </d-card>
    </d-container>
</template>

<script>
import performance from "@/mixins/performance";
import Loading from "vue-loading-overlay";
import ExportPerformance from "@/components/common/ExportPerformance.vue";
import CalendarPicker from "@/components/form/calendarPicker.vue";
import { PerformanceService } from "@/main";
import TransactionRowItem from "@/components/transactions/transactionRowItem.vue";
import * as Sentry from "@sentry/browser";

export default {
    mixins: [performance],

    components: {
        Loading,
        CalendarPicker,
        ExportPerformance,
        TransactionRowItem
    },

    data() {
        return {
            advertiserNames: [],
            websites: [],
            reviewed: null,
            isPerformanceLoading: true,
            isLoading: false,
            fullPage: true,
            page: 1,
            records: 0,
            type: "advertiser",
            Affiliate: [],
            Performances: [],
            transactions: [],
            areAdvertiserTransactions: false,
            isOpened: false,

            dateRange: {
                from: "",
                to: ""
            },

            columns: [
                "advertiser",
                "approvedNumber",
                "approved",
                "pendingNumber",
                "open",
                "disapprovedNumber",
                "disapproved",
                "number",
                "total",
                "approvalRate"
            ],

            clientTableOptions: {
                perPage: 25,
                childRowTogglerFirst: false,
                recordsPerPage: [25, 50, 100],
                skin: "transaction-history table dataTable",
                texts: {
                    limit: "Show",
                    count: ""
                },
                columnsDisplay: {
                    approved: "desktop",
                    approvedNumber: "desktop",
                    pendingNumber: "desktop",
                    open: "desktop",
                    disapprovedNumber: "desktop",
                    disapproved: "desktop",
                    approvalRate: "desktop"
                },
                columnsClasses: {
                    advertiser: "dashboard",
                    approveNnumber: "approved",
                    approved: "approved",
                    pendingNumber: "pending",
                    disapprovedNumber: "disapproved",
                    disapproved: "disapproved",
                    open: "pending"
                },
                headings: {
                    id: "#",
                    advertiser: "ADVERTISER",
                    approvedNumber: "#",
                    approved: "APPROVED",
                    pendingNumber: "#",
                    open: "PENDING",
                    disapprovedNumber: "#",
                    disapproved: "DISAPPROVED",
                    number: "#",
                    total: "TOTAL",
                    showTransactions: "",

                    approvalRate: function(h) {
                        return (
                            <div>
                                APPROVAL RATE{" "}
                                <i class="material-icons mr-3">help</i>
                            </div>
                        );
                    }
                },
                headingsTooltips: {
                    approvalRate: () =>
                        "The percentage of total transaction amount that is approved."
                }
            }
        };
    },

    computed: {
        websitesSelectValues() {
            return this.websites.map(el => el = ({ value: el.id, text: el.domain }))
        }
    },

    methods: {

        async getQueryParams(queryParams)   {
            try {
                if (!this.checkQueryParamsPresence(queryParams)) {
                    this.areAdvertiserTransactions = false;
                    this.columns = this.columns.filter(
                        el => el !== "showTransactions"
                    );
                    return;
                }

                this.transactions = []
                this.isOpened = true
                this.columns.push("showTransactions");
                this.areAdvertiserTransactions = true;
                this.extraFilter.chosenAdvertiserNamesFilter =
                    queryParams["performance_filter_name"];
                this.extraFilter.website = queryParams["website_ids[]"];
                this.dateRange.from = queryParams["date_start"];
                this.dateRange.to = queryParams["date_end"];
                this.reviewed = queryParams["reviewed"];
                await this.getPerformance(
                    queryParams["performance_type"],
                    1,
                    true,
                    this.reviewed,
                );
                await this.getAdvertiserTransactions(
                    queryParams["performance_type"],
                    1,
                    true,
                    this.reviewed
                );
            } catch (error) {
                Sentry.captureException(error);
                console.error(error);
            }
        },

        getCurrencies(websiteDomain) {
            const found = this.websites.find(website => {
                return website.domain === websiteDomain;
            });
            return found ? found.currency.code : "EUR";
        },

        async getAdvertiserNames() {
            this.advertiserNames = await PerformanceService.getAdvertiserNames();
            this.advertiserNames = this.advertiserNames.map(advertiserName => {
                return {
                    value: advertiserName,
                    text: advertiserName
                };
            });
        },

        toggleShowTransactions() {
            this.isOpened = !this.isOpened;
        }
    },

    async created() {
        await this.getQueryParams(this.$route.query);
        this.getAdvertiserNames();
    }
};
</script>
